export enum UserPartnerType {
  OEM_PARTNER_TYPE = 'OEM',
  MSP_PARTNER_TYPE = 'MSP',
}
